module.exports = __webpack_public_path__ + "img/01.214de0ba.png";